import { cn } from "@/lib/cn";

/** Compact SoC ring + percentage label. */
export function SocArc({
  pct,
  size = 56,
  strokeWidth = 6,
  className,
}: { pct: number; size?: number; strokeWidth?: number; className?: string }) {
  const r = (size - strokeWidth) / 2;
  const c = 2 * Math.PI * r;
  const dash = (Math.max(0, Math.min(100, pct)) / 100) * c;
  const tone = pct < 15 ? "text-critical" : pct < 30 ? "text-warn" : pct > 95 ? "text-warn" : "text-charge";
  return (
    <div className={cn("relative inline-grid place-items-center", className)} style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="currentColor" strokeOpacity={0.15} fill="none" strokeWidth={strokeWidth} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${c}`}
          className={tone}
          stroke="currentColor"
        />
      </svg>
      <div className="absolute inset-0 grid place-items-center">
        <span className="text-[11px] font-semibold num">{Math.round(pct)}<span className="text-[8px] text-text-muted">%</span></span>
      </div>
    </div>
  );
}
